var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.areGamesLoaded)?_c('iframe',{staticClass:"w-full",staticStyle:{"height":"calc(100vh - 120px)"},attrs:{"src":_vm.virtualGameSrc}}):_c('div',{staticClass:"spinner-container"},[_c('SpinnerBars')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f0eec4da","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/modules/results/virtual/VirtualResultsContainer.vue
// module id = 2225
// module chunks = 0